// 03/25

import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { HeroBackgroundStrokes } from '../components/common/SyncratikLogo';
import newsData from '../data/news.json';

const NewsPage = () => {
    const [isLoading, setIsLoading] = useState(true);
    const [showShimmer, setShowShimmer] = useState(false);

    useEffect(() => {
        // Set shimmer delay display - only show if loading time exceeds 200ms
        const shimmerTimer = setTimeout(() => {
            if (isLoading) {
                setShowShimmer(true);
            }
        }, 200);

        // Simulation actual loading completed
        const loadTimer = setTimeout(() => {
            setIsLoading(false);
            setShowShimmer(false);
        }, 100); // Loads quickly and usually doesn't trigger shimmer

        return () => {
            clearTimeout(shimmerTimer);
            clearTimeout(loadTimer);
        };
    }, []); // Empty dependency array - run once on mount to prevent infinite loop

    // formate the date
    const formattedPublishedDate = (publishedDate) => {
        return new Date(publishedDate).toLocaleDateString("en-US", {
            year: "numeric",
            month: "long",
            day: "numeric"
        });
    }

    // Shimmer element - only displayed when really needed
    if (isLoading && showShimmer) {
        return (
            <div className="bg-gray-10 min-h-screen relative">
                {/* Background with logo strokes */}
                <div className="absolute inset-0 pointer-events-none overflow-hidden">
                    <HeroBackgroundStrokes
                        className="absolute inset-0 w-full"
                        style={{
                            height: '100%',
                            backgroundImage: 'url(/assets/logo-strokes.png)',
                            backgroundRepeat: 'repeat-y',
                            backgroundSize: '100% 2216px',
                            backgroundPosition: 'center top'
                        }}
                    />
                </div>

                <div className="relative py-20">
                    <div className="container-content">
                        <div className="text-left mb-6">
                            <div className="h-8 bg-gradient-to-r from-[#BD83FB]/20 to-[#671CA8]/20 animate-pulse rounded w-64"></div>
                        </div>

                        <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-2 gap-8">
                            {[1, 2, 3, 4].map((i) => (
                                <div key={i} className="bg-transparent border border-transparent rounded-lg shadow-lg overflow-hidden">
                                    <div className="w-full h-48 bg-gradient-to-r from-[#BD83FB]/20 to-[#671CA8]/20 animate-pulse"></div>
                                    <div className="p-6">
                                        <div className="h-6 bg-gradient-to-r from-[#BD83FB]/20 to-[#671CA8]/20 animate-pulse rounded w-3/4 mb-3"></div>
                                        <div className="h-4 bg-gradient-to-r from-[#BD83FB]/20 to-[#671CA8]/20 animate-pulse rounded w-1/2"></div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="bg-gray-10 min-h-screen relative pt-16 pb-60">
            {/* Background with logo strokes */}
            <div className="absolute inset-0 pointer-events-none overflow-hidden">
                <HeroBackgroundStrokes
                    className="absolute inset-0 w-full"
                    style={{
                        height: '100%',
                        backgroundImage: 'url(/assets/logo-strokes.png)',
                        backgroundRepeat: 'repeat-y',
                        backgroundSize: '100% 2216px',
                        backgroundPosition: 'center top'
                    }}
                />
            </div>

            <div className="relative">
                <div className="container-content">
                    <div className="text-left mb-6">
                        <h1 className="text-h1 text-gray-95">All News Articles</h1>
                    </div>

                    {/* Loop through all the news in the json file */}
                    <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-2 gap-8">
                        {[...newsData].sort((a, b) => new Date(b.datePublished) - new Date(a.datePublished)).map((news) => (
                            //  card component
                            <li key={news.slug}>
                                <Link to={`/news/${news.slug}`}>
                                    <div className="rounded-lg overflow-hidden hover:border-gray-70 hover:scale-105 transition-all duration-300 cursor-pointer border border-transparent backdrop-blur-sm bg-gray-10/5">
                                        <img
                                            src={news.imageUrl.startsWith('http') ? news.imageUrl : `/news/${news.imageUrl}`}
                                            alt={news.title}
                                            className="w-full h-48 object-cover"
                                            loading="lazy"
                                            width="400"
                                            height="192"
                                        />
                                        <div className="p-6">
                                            <h2 className="text-h3 text-gray-95 pb-1">{news.title}</h2>
                                            <p className="text-paragraph text-gray-50">{formattedPublishedDate(news.datePublished)}</p>
                                        </div>
                                    </div>
                                </Link>
                            </li>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default NewsPage;
